import TombolaBaseComponent from '@/components/base/base.component';
import SearchResultsItemComponent from '@/components/home/_components/search-bar/_components/search-results-list/_components/search-results-item';
import { SearchResult } from '@/components/home/_components/search-bar/_domain/models/search-result-model';
import { Component, Prop } from 'vue-property-decorator';
import { IChatServerService } from '@/app-modules/server-service';

@Component({
  name: 'SearchResultsListComponent',
  components: {
    searchResultsItem: SearchResultsItemComponent
  }
})
export default class SearchResultsListComponent extends TombolaBaseComponent {
  @Prop() public server: IChatServerService;
  @Prop() public searchResults: SearchResult[];

  private get hasSearchResults(): boolean {
    return this.searchResults && this.searchResults.length > 0;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/home/_components/search-bar/_components/search-results-list/search-results-list.component.ts